export default __webpack_public_path__ + "static/media/news4.da7762f8.mp4";